import { ErrorHandler, Injectable } from '@angular/core';
// import { ErrorMessages } from './custom-error-messages';

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
    handleError(error: any): void {
        console.error(error);
    }

}
